<template>
  <div class="service-container">
    <!-- <div class="desc_wrap">
      <h1 class="media_font_size_70" style="margin:10px 0;">展馆及周边服务</h1>
      <span class="media_font_size_50">文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明</span>
    </div> -->
    <div class="video_wrap">
      <div class="title">
        <h2 class="media_font_size_70">{{ $t("homepage.exhibitionName") }}</h2>
        <!-- <span>Auto Guangzhou 2024</span> -->
      </div>
      <video
        src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_2025.mp4"
        controls
      ></video>
    </div>
    <div class="news_wrap">
      <div class="title">
        <h2 class="media_font_size_70">{{ $t("homepage.notice") }}</h2>
        <!-- <span>NOTICE</span> -->
      </div>
      <div class="news_container">
        <div class="news_item" v-for="(item,index) in noticeList" :key="index" @click="handelJump('/newsCenter?tab=0&noticeId=',item.noticeId,item)">
          <!-- <div :style="{'backgroundImage':'url('+item.img+')'}"></div> -->
          <img :src="item.img" alt="">
          <span class="item_title media_font_size_50">{{item.title}}</span>
          <span class="item_date media_font_size_30">{{item.date}}</span>
        </div>
      </div>
      <div class="default_btn media_font_size_50" @click="handelJump('/newsCenter?tab=0')">
        <span>{{noticeList.length>0?$t("public.more"):$t("public.nomore")}}</span>
      </div>
    </div>
    <div class="news_wrap">
      <div class="title">
        <h2 class="media_font_size_70">{{ $t("homepage.news") }}</h2>
        <!-- <span>NEWS</span> -->
      </div>
      <div class="news_container">
        <div class="news_item" v-for="(item,index) in newsList" :key="index" @click="handelJump('/newsCenter?tab=1&newsId=',item.newsId,item)">
          <!-- <div :style="{'backgroundImage':'url('+item.img+')'}"></div> -->
          <img :src="item.img" alt="">
          <span class="item_title media_font_size_50">{{item.title}}</span>
          <span class="item_date media_font_size_30">{{item.date}}</span>
        </div>
      </div>
      <div class="default_btn media_font_size_50" @click="handelJump('/newsCenter?tab=1')" v-if="newsList.length>0">
        <span>{{newsList.length>0?$t("public.more"):$t("public.nomore")}}</span>
        <!-- <span>{{newsList.length>0?'MORE':'NO MORE'}}</span> -->
      </div>
    </div>
    <div class="map_wrap">
      <img src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/map.png" alt />
    </div>
    <div class="co_wrap">
      <div class="title">
        <h2 class="media_font_size_70">{{ $t("homepage.coMedia") }}</h2>
        <!-- <span class="mb_80">MEDIA</span> -->
      </div>
      <div class="swiper-container coswiper">
        <swiper :options="swiperOption" class="swiper" ref="mySwiper">
          <swiper-slide class="slide" v-for="(item,index) in logoList" :key="index">
            <img :src="item.img" alt="">
            <!-- <div class="slide_item" :style="{'backgroundImage':'url('+item.img+')'}"></div> -->
          </swiper-slide>
        </swiper>
      </div>
      <div class="default_btn media_font_size_50" @click="handelJump('/friendlyLink?tab=2')">
        <span>{{ $t("public.more") }}</span>
        <!-- <span>MORE</span> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
  },
  data() {
    return {
      logoList: [
      {
          id: "256",
          img:"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/friendlyLink/link256.jpg"
        },
        {
          id: "252",
          img:"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/friendlyLink/link252.png"
        },
        {
          id: "1",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_1.jpg",
          url: ""
        },
        {
          id: "2",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_2.jpg",
          url: ""
        },
        {
          id: "3",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_3.jpg",
          url: ""
        },
        {
          id: "4",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_4.jpg",
          url: ""
        },
        {
          id: "5",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_5.jpg",
          url: ""
        },
        {
          id: "6",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_6.jpg",
          url: ""
        },
        {
          id: "7",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_7.jpg",
          url: ""
        },
        {
          id: "8",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_8.jpg",
          url: ""
        },
        {
          id: "9",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_9.jpg",
          url: ""
        },
        {
          id: "10",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_10.jpg",
          url: ""
        },
        {
          id: "11",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_11.jpg",
          url: ""
        },
        {
          id: "12",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_12.jpg",
          url: ""
        },
        {
          id: "13",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_13.jpg",
          url: ""
        },
        {
          id: "14",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_14.jpg",
          url: ""
        },
        {
          id: "15",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/link/link_15.jpg",
          url: ""
        }
      ],
      noticeList:[
      // {
      //   noticeId:10,
      //     title:'温馨提示：广州国际车展最后一天展览结束时间延长至下午17:30',
      //     img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner4.jpg",
      //     date:'2024-11-23',
      //     detail:`<img src='https://faststatic.ccnfgame.com/cos/vrshow/autoShow/news/img/news_all/21.png' alt/>`
      // },
      // {
      //   noticeId:11,
      //     title:'媒体接待中心11月19日起将移至广交会展馆A区',
      //     img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner4.jpg",
      //     date:'2024-11-18',
      //     detail:`<img src='https://faststatic.ccnfgame.com/cos/vrshow/autoShow/notice/captrue/notice_11.png' alt/>`
      // },
      {
        noticeId:9,
          title:'第二十三届广州国际汽车展览会媒体注册通知',
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_25.jpg",
          date:'2025-11-06',
          detail:`<img src='https://faststatic.ccnfgame.com/cos/vrshow/autoShow/news/img/news_all/media_25.png' alt/>`
      },
     
      ],
      newsList: [
        {
          newsId: 44,
          title:'见证中国汽车产业“十四五”收官盛典',
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/news/newsContent/44/44_1.png",
          date: "2025-11-14",
        },
         {
          newsId: 43,
          title: this._i18n.locale == "zh"?"共话破局与未来 2025广州汽车发展高峰论坛11月开启":"Driving Innovation and Global Growth 2025 Guangzhou Auto Industry Development Summit Kicks Off in November",
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_25.jpg",
          date: "2025-11-12",
        },
        {
          newsId: 'mp01',
          title:'2024广州国际车展圆满闭幕 | 2025广州国际车展将于2025年11月21日至30日举办',
          img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner4.jpg",
          date: "2024-11-24",
          url:"https://mp.weixin.qq.com/s/mOE-docGqi54MK2OT-Ckpg"
        }
        // {
        //   newsId: 41,
        //   title: "2024广州汽车发展高峰论坛圆满落幕",
        //   img: "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/news/img/news_all/c40.jpeg",
        //   date: "2024-11-17",
        //   detail: `<img src='https://faststatic.ccnfgame.com/cos/vrshow/autoShow/news/img/news_all/40.png' alt/>`,
        // }
      ],
      swiperOption: {
        // 所有的参数同 swiper 官方 api 参数
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop:true,
        slidesPerView: 5,
          spaceBetween: 40,
        // autoHeight: true,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
         loop: false,
      }
    };
  },
  methods:{
    handelPre(){
      
    },
    handelNext(){},
    handelJump(path,id,item){
      console.log(id)
      if(typeof id == 'string'){
        window.open(item.url, '_blank')

      }else{        
        console.log(path+id);
        
        this.$router.push(path+(id?''+id:''))
      }
    }
  }
};
</script>

<style lang="scss">
.service-container {
  width: 1200px;
  .desc_wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    margin-bottom: 102px;
    >h1{
      font-size: 40px;
    }
    > span {
      color: rgba($color: #fff, $alpha: 0.5);
      font-size: 24px;
      line-height: 50px;
    }
  }
  .video_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    > video {
      width: 1200px;
      margin-top: 49px;
    }
  }
  .news_wrap {
    margin-top: 99px;
    .news_container {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      .news_item {
        display: flex;
        flex-direction: column;
        color: #fff;
        margin-right: 30px;
        >img {
          width: 370px;
          height: 260px;
          background-size: cover;
          background-position: center;
        }
        .item_title {
          color: #fff;
          width: 370px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 26px 0px 50px 0px;
          font-size: 22px;
          line-height: 30px;
          height: 60px;
        }
        .item_date {
          font-size: 16px;
          color: rgba($color: #fff, $alpha: 0.5);
        }
      }
    }
  }
  .map_wrap {
    display: flex;
    margin: 120px 0px;
    > img {
      width: 100%;
      height: 908px;
    }
  }
  .co_wrap {
    .swiper-container {
      // height: 100px;
      
      .swiper {
        // height: 80px;
        .slide {
          // width: 125px;
          // height: 70px;
          >img{
            width: 100%;
            height: 100%;
          }
          .slide_item {
            // width: 100%;
            height: 100px;
            background: #fff;
            background-size: cover;
            background-position: center;
          }
        }
      }
    }
  }
}
.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  margin-bottom: 30px;
  > h2 {
    font-size: 36px;
    margin-bottom: 30px;
  }
  > span {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}
.default_btn {
  width: 300px;
  // height: 60px;
  padding:10px 18px;
  background: rgba($color: #fff, $alpha: 0.2);
  border-radius: 50px;
  // line-height: 60px;
  text-align: center;
  color: rgba($color: #fff, $alpha: 0.5);
  font-size: 20px;
  margin: 60px auto;
  display: flex;
  flex-direction: column;
  >span{
    line-height: 26px;
  }
}
.mb_80{
  margin-bottom: 80px;
}

@media screen and (max-width: 1000px) {
  .service-container {
    .desc_wrap {
    > span {
      line-height: 120px;
    }
  }
  }
}

</style>


// WEBPACK FOOTER //
// service.vue?fd675536